'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactRouter = require('react-router');
var _reactRedux = require('react-redux');
var _reduxPagan = require('redux-pagan');
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _omit = require('lodash/omit');var _omit2 = _interopRequireDefault(_omit);

var _components = require('../../components');

var _professionals = require('../../redux/modules/professionals');


var _appendLocale = require('../../helpers/appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);
var _checkRtlLanguage = require('../../utils/checkRtlLanguage');var _checkRtlLanguage2 = _interopRequireDefault(_checkRtlLanguage);
var _Slider = require('../../components/HomePagePropertiesCarousel/components/Slider');
var _constants = require('../../constants');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Components
// Redux
// Helpers
var ProfessionalsCarouselContainer = function (_Component) {_inherits(ProfessionalsCarouselContainer, _Component);function ProfessionalsCarouselContainer() {var _temp, _this, _ret;_classCallCheck(this, ProfessionalsCarouselContainer);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.


    openDetailsHandler = function (evt, propertyId) {var _evt$target =
      evt.target,classList = _evt$target.classList,parentElement = _evt$target.parentElement;

      var isArrowIcon = classList.contains(_Slider.homeCarouselArrowClassName) ||
      parentElement.classList.contains(_Slider.homeCarouselArrowClassName);

      if (isArrowIcon) {
        return;
      }

      propertyId === 'broker_community_cell' ?
      _reactRouter.browserHistory.push((0, _appendLocale2.default)(_this.props.locale, '/professionals/broker')) :
      _this.openDetails(evt, propertyId);
    }, _this.

    openDetails = function (evt, professionalId) {
      var route = (0, _appendLocale2.default)(
      _this.props.locale, '/company/' +
      professionalId);


      if (evt.ctrlKey || evt.metaKey) {
        window.open(route);
      } else {
        _reactRouter.browserHistory.push(route);
      }
    }, _this.

    changeActiveIdx = function (index) {return _this.props.changeSliderActiveIdx(index);}, _this.

    renderPropertiesCarousel = function () {return (
        _react2.default.createElement(_components.ProfessionalsCarousel, {
          screenWidth: _this.props.screenWidth,
          locale: _this.props.locale,
          translate: _this.props.translate,
          professionals: _this.props.professionalsData,
          handleClick: _this.openDetailsHandler,
          isMobile: _this.props.isMobile,
          isRtl: _this.props.isRtl,
          activeIdx: _this.props.sliderActiveIdx,
          changeActiveIdx: _this.changeActiveIdx }));}, _temp), _possibleConstructorReturn(_this, _ret);}ProfessionalsCarouselContainer.prototype.componentDidMount = function componentDidMount() {this.props.receiveProfessionals();};ProfessionalsCarouselContainer.prototype.



  render = function render() {
    return (
      this.renderPropertiesCarousel());

  };return ProfessionalsCarouselContainer;}(_react.Component);


ProfessionalsCarouselContainer.propTypes = {
  screenWidth: _propTypes2.default.number,
  translate: _propTypes2.default.func,
  locale: _propTypes2.default.string.isRequired,
  isMobile: _propTypes2.default.bool,
  isRtl: _propTypes2.default.bool,
  professionalsData: _propTypes2.default.array,
  receiveProfessionals: _propTypes2.default.func,
  changeSliderActiveIdx: _propTypes2.default.func,
  sliderActiveIdx: _propTypes2.default.number };


var brokerCommunityData = {
  id: 'broker_community_cell',
  image: _constants.brokerCommunityLogo,
  name: { he: 'רשת ברוקר' },
  title: { he: 'סטנדרט חדש בנדל״ן' } };


var mapStateToProps = function mapStateToProps(state) {return {
    translate: (0, _reduxPagan.getLang)(state.lang, 'static'),
    locale: state.lang.locale,
    isMobile: state.windowDimentions.isMobile,
    isRtl: (0, _checkRtlLanguage2.default)(state.lang.locale),
    professionalsData: [brokerCommunityData].concat(state.professionals.professionals || []),
    sliderActiveIdx: state.professionals.activeSlideIdx };};exports.default =


(0, _reactRedux.connect)(mapStateToProps, {
  receiveProfessionals: _professionals.receiveProfessionals,
  changeSliderActiveIdx: _professionals.changeProfessionalsSliderActiveIdx })(
ProfessionalsCarouselContainer);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/ProfessionalsCarouselContainer/ProfessionalsCarouselContainer.js
// module id = 2945
// module chunks = 0